import { useEffect, useRef } from 'react';
import { useRelatedPrdModalStore } from '@store/modalStore';
import useModalManager from './useModalManager';

/**
 * 연관상품 모달 상태 복원을 위한 훅
 * 페이지 로드 시 저장된 연관상품 모달 상태를 복원합니다.
 */
export const useRelatedPrdModalRestore = () => {
  const { relatedPrdModalState, shouldRestoreRelatedPrdModal, markAsRestored } =
    useRelatedPrdModalStore();
  const { openRelatedPrdModal } = useModalManager();

  // Strict Mode에서 중복 실행 방지를 위한 ref
  const hasRestoredRef = useRef(false);

  useEffect(() => {
    // 이미 복원했으면 실행하지 않음
    if (hasRestoredRef.current) return;

    const restoreModal = () => {
      if (!shouldRestoreRelatedPrdModal()) return;

      if (relatedPrdModalState) {
        // 복원 모드에서는 상태를 다시 저장하지 않음
        openRelatedPrdModal({
          placement: relatedPrdModalState.placement,
          className: relatedPrdModalState.className,
          onClose: () => {
            // 모달 닫을 때는 별도 처리 없음 (useModalManager에서 처리)
          },
          products: relatedPrdModalState.products,
          value: relatedPrdModalState.value,
          isRestore: true, // 복원 모드 플래그
        });

        // 복원 완료 표시
        markAsRestored();
        hasRestoredRef.current = true; // 복원 완료 표시
      }
    };

    // 컴포넌트 마운트 시에만 실행
    restoreModal();
  }, []); // 빈 의존성 배열로 한 번만 실행
};
